import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { isFromSearch } from 'lib/utils/query-params'
import AnchorLink from './AnchorLink'
import styles from './EventNavigation.module.scss'

export default function EventNavigation({
  general,
  prices,
  additionalServices,
  reviews,
  faq,
  price,
  guests = null,
  matterport = null,
  video = null,
  contactInfo,
}) {
  const [shouldShowBack, setShouldShowBack] = useState(false)
  const router = useRouter()

  useEffect(() => {
    if (isFromSearch(router)) {
      setShouldShowBack(true)
    }
  }, [router.query])

  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.wrap}>
          <div className={styles.links}>
            {shouldShowBack && (
              <p className={styles.back} role="button" onClick={router.back}>
                <img
                  src="/img/arrow-pink.svg"
                  className={styles.arrow}
                  role="presentation"
                  alt=""
                  width="13"
                  height="13"
                  loading="lazy"
                />
                Takaisin hakuun
              </p>
            )}
            {general && <AnchorLink anchor="yleista" title="Yleistä" />}
            {contactInfo && (
              <AnchorLink anchor="yhteystiedot" title="Yhteystiedot" />
            )}
            {prices && <AnchorLink anchor="hinnat" title="Hinnat" />}
            {additionalServices && (
              <AnchorLink anchor="palvelut" title="Lisäpalvelut" />
            )}
            {reviews && <AnchorLink anchor="arvostelut" title="Arvostelut" />}
            {faq && <AnchorLink anchor="ukk" title="UKK" />}
            {video && <AnchorLink anchor="videoembed" title="Video" />}
            {matterport && <AnchorLink anchor="matterport" title="3D" />}
          </div>
          <div className={styles.pricing}>
            {guests && (
              <span className={styles.guests}>
                <img
                  className={styles.guestIcon}
                  src="/img/user-pink.svg"
                  width="15"
                  height="15"
                  alt=""
                  role="presentation"
                  loading="lazy"
                />
                {guests}
              </span>
            )}
            {price}
          </div>
        </div>
      </div>
    </section>
  )
}
